import style from "./Dropdown.module.css";
import { forwardRef, useEffect, useRef, useState } from "react";

const Dropdown = forwardRef((props, ref) => {
  const [importedStyle, setImportedStyle] = useState({});
  const dropdownRef = useRef();

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  // useEffect(() => {
  //   setImportedStyle(props.style);
  // },[props.style])

  useEffect(() => {
    if (props.show) {
      // console.log(dropdownRef.current.getBoundingClientRect().bottom)
      // console.log(getWindowDimensions())

      if (props.type === "cursor") {
        let x = props.cursorPos.clientX;
        let y = props.cursorPos.clientY;
        let tempStyle = {
          ...props.style,
        };
        // tempStyle.bottom = getWindowDimensions().height - y;

        let top = 0;
        if(y + ref.current.offsetHeight > window.innerHeight) {
          top = y - ref.current.offsetHeight;
        }else{
          top = y ;
        }


        tempStyle.top = top + "px";;
        tempStyle.left = x + "px";
        setImportedStyle(tempStyle);
      } else {
        if (
          props.style.top + getWindowDimensions().height * 0.25 >
          getWindowDimensions().height
        ) {
          let tempStyle = {
            ...props.style,
          };
          tempStyle.bottom = getWindowDimensions().height - tempStyle.top;
          tempStyle.top = "auto";
          // console.log("reset", tempStyle);
          setImportedStyle(tempStyle);
        } else {
          setImportedStyle(props.style);
        }
      }
    }
  }, [props.show, props.style]);

  return (
    <div  className={`${style.dropdownContainer} ${props.show && style.show}`}>
      <div
        ref={ref}
        className={`${style.dropdown}`}
        style={importedStyle}
      >
        {props.children}
      </div>
      <div className={style.dropdownBackground} onClick={props.onClose}></div>
    </div>
  );
});

export default Dropdown;
